import { Component } from 'react';
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import CartErrors from 'cart/components/CartErrors';
import { isChargable } from 'checkout/checkout/helpers';
import { Button } from 'common/components/layout';
import { logEvent } from 'common/helpers/analytics';
import { chargeCart } from 'redux/cart/actions';

class Charge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false
    };
  }

  handleCharge = async (e) => {
    const { props } = this;
    const { executeRecaptcha } = props.googleReCaptchaProps;
    const recaptchaToken = await executeRecaptcha('checkout');
    this.setState({ isSubmitting: true });
    e.preventDefault();
    const successFunction = (order) => {
      this.setState({ isSubmitting: false });
      logEvent('Checkout', 'V1 Complete');
      props.history.push(`/checkout/receipt/${order.id}`);
    };
    const errorFunction = () => {
      this.setState({ isSubmitting: false });
    };
    props.chargeCart(recaptchaToken, successFunction, errorFunction);
  };

  render() {
    const { cart } = this.props;
    const { isSubmitting } = this.state;
    if (!isChargable(cart)) {
      return <CartErrors cart={cart} />;
    }
    return (
      <div className="c7-checkout__content__buttons">
        <Button
          type="button"
          className="c7-button"
          onClick={this.handleCharge}
          disabled={isSubmitting}
        >
          Complete Order
        </Button>
        <div />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  settings: state.setting
});

export default withGoogleReCaptcha(
  withRouter(connect(mapStateToProps, { chargeCart })(Charge))
);
